import React from "react"
import img from "../../assets/paymentCanceled.png"
import { Link } from "react-router-dom"

export default function PaymentCancel() {
  return (
    <div className="container py-5">
      <div className="row align-items-center">
        <div className="col-12 col-lg-6 mb-5 mb-lg-0">
          <h1 className="brand-dark-purple fw-bold display-5 mb-3">
            Payment cancelled
          </h1>

          <p className="text-muted fs-5 mb-4">
            Your payment was not completed. No money has been taken.
          </p>

          <div className="d-flex flex-wrap gap-3">
       
<Link to="/" className="btn brand-purple-outline min-width">   Back to home</Link>
        
          </div>
        </div>

        <div className="col-12 col-lg-6 text-center">
          <img
            src={img}
            alt="Payment cancelled"
            className="illustration-img"
          />
        </div>
      </div>
    </div>
  )
}
